import { InvestmentAllocation, InvestmentEntity } from '../../../models/InvestmentEntity';
import Investor from '../../../models/Investor';
import { WizardStep } from './adminEntityAssociationWizardTypes';

export function decideInitialStep(entities: InvestmentEntity[]): WizardStep {
  return entities.length > 0 ? 'selection' : 'create';
}

export function buildAssociateEntityPath(
  investorId: string,
  step: WizardStep,
  entityId?: string,
): string {
  if (step === 'lookup') {
    return `/associate-entity/${investorId}`;
  }
  return `/associate-entity/${investorId}${entityId ? `/${entityId}` : ''}/${step}`;
}

export function sumAllocations(allocations: InvestmentAllocation[] = []): number {
  return allocations.reduce((sum, allocation) => sum + Number(allocation.allocatedAmount), 0);
}

export function remainingCommitment(
  investor: Investor | null | undefined,
  allocations: InvestmentAllocation[] = [],
): number {
  return (investor?.committedInvestment || 0) - sumAllocations(allocations);
}

export function remainingCommitmentFromInvestor(investor: Investor | null | undefined): number {
  return (investor?.committedInvestment || 0) - (investor?.totalAllocatedAmount || 0);
}

export function hasRemainingCommitmentFromInvestor(investor: Investor | null | undefined): boolean {
  return remainingCommitmentFromInvestor(investor) > 0;
}
